import { render, staticRenderFns } from "./GalleryResources.vue?vue&type=template&id=43a73b16&"
import script from "./GalleryResources.vue?vue&type=script&lang=js&"
export * from "./GalleryResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports